export default __webpack_public_path__ + "static/carousel-hero-lite-d9bec771df9438364ec5fab2ac0835da.png";